/** @module csi/widget/CheckedMultiRefSelect */
define([
	"dojo/_base/declare",
	"csi",
	"csi/action",
	"csi/widget/icon/Util",
	"./CheckedMultiSelectDropdown",
	"./RefSelectMixin"
], function(declare, csi, csiAction, iconUtil, CheckedMultiSelectDropdown, RefSelectMixin) {

	return declare([CheckedMultiSelectDropdown, RefSelectMixin], {
		multiSelect: true,

		/** @property {boolean} includingIcon - indicates whether includes icon or not */
		//includingIcon: null,

		/** @property {string} colorAttribute - the attribute name of the color */
		//colorAttribute: null,

		/** @property {string} iconAttribute - the attribute name of the icon */
		//iconAttribute: null,

		labelFunc: function(item, store) {
			var label = this.inherited(arguments);
			var includingIcon = this.params.includingIcon;

			if (item.node && !!includingIcon) {
				const colorAttribute = this.params.colorAttribute;
				const iconAttribute = this.params.iconAttribute;

				this.labelType = "html";
				label = iconUtil.getTaskActionIconHtml(item.node[iconAttribute], item.node[colorAttribute], label);
			}

			return label;
		},

		_handleOnChange: function(/*anything*/ newValue, /*Boolean?*/ priorityChange) {
			var bPopup = (newValue == csi.DIALOG_URL) && (priorityChange === true);
			if (bPopup) {
				// _onChangeActive is set to false not to change the value of the heading to "Go to Dialog"
				this._onChangeActive = false;

				// if current value is already set then assign it to _resetValue and _csiResetValue
				this.setWidgetSelections(this._currentValue || this._lastValueReported);
				this.goToDialog();
			}

			CheckedMultiSelectDropdown.prototype._handleOnChange.call(this, newValue, priorityChange);

			if (bPopup) {
				this._onChangeActive = true;
			}

			if (newValue != csi.DIALOG_URL) {
				this.setCurrentValue(this.value);
			}
		},

		/**
		 * remember the current value to select it in the "Go to Dialog"
		 * @param {any Value} val - any new values
		 */
		setCurrentValue: function(value) {
			if (value != csi.DIALOG_URL) {
				this._resetValue = this._csiResetValue = this._currentValue = value;

				if (this.dropDown) {
					this.dropDown.value = value;
				}
			}
		},

		/**
		 * Return selected urls in widget.
		 * @return {string[]}
		 */
		getWidgetSelections: function() {
			return this.get("externalValue");
		},

		/**
		 * Apply selections from the "Go to Dialog" view to the widget
		 * @param {string[]} value
		 */
		setWidgetSelections: function(value) {
			this.resetSelected(value);
		}
	});
});